import { financeFlowSteps } from '@/mocks/corporateFinanceData';
import { useTranslation } from 'react-i18next';

export default function FlowSteps() {
  const { t } = useTranslation();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('corporateFinance.flow.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {t('corporateFinance.flow.title')}
          </h2>
          {String(t('corporateFinance.flow.subtitleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="section-title-en text-accent-500 text-[15px] tracking-[0.12em] mb-4">{__s}</p>))}
          <div className="gold-line mx-auto mb-5"></div>
          {String(t('corporateFinance.flow.lead')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">{__s}</p>))}
        </div>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 md:gap-0">
          {financeFlowSteps.map((step, idx) => (
            <div key={idx} className="flex md:flex-col items-center gap-4 md:gap-0 flex-1 relative">
              <div className="w-12 h-12 rounded-full bg-accent-500/10 border border-accent-500/30 flex items-center justify-center flex-shrink-0">
                <span className="text-accent-600 text-[15px] font-bold tracking-[0.06em]">{step.step}</span>
              </div>

              <div className="md:text-center md:mt-4">
                <h4 className="font-heading text-[15px] md:text-[16px] text-foreground-900 tracking-[0.06em] mb-1.5">
                  {t(`corporateFinance.flow.step${idx + 1}.title`)}
                </h4>
                <p className="text-[13px] md:text-[14px] text-foreground-500 tracking-[0.03em] leading-relaxed">
                  {t(`corporateFinance.flow.step${idx + 1}.desc`)}
                </p>
              </div>

              {idx < financeFlowSteps.length - 1 && (
                <>
                  <div className="hidden md:block absolute top-6 left-[calc(50%+30px)] w-[calc(100%-60px)]">
                    <div className="h-[1px] bg-gradient-to-r from-accent-500/40 to-accent-500/10"></div>
                  </div>
                  <div className="md:hidden ml-6 pl-6 border-l border-accent-500/20 h-8"></div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
